import React from 'react';
import { silenceIcon } from '@chordbaker/design';

interface SilenceIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const paths = silenceIcon.elements as { d: string }[];

/** Crossed-out note: a slot with no chord (it plays silent). */
const SilenceIcon: React.FC<SilenceIconProps> = ({
  size = silenceIcon.defaultSize,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={silenceIcon.viewBox}
    fill={color}
    className={className}
    aria-hidden="true"
  >
    {paths.map(path => (
      <path key={path.d} d={path.d} />
    ))}
  </svg>
);

export default SilenceIcon;
